<template>
    <v-data-table v-bind="$attrs" :headers="filteredHeaders" :expanded.sync="expanded"
        @update:items-per-page="onUpdateItemsPerPage" @update:page="onPageUpdate" :item-class="itemRowclass">

        <template v-slot:expanded-item="props">
            <td colspan="100%" :class="nested">
                <slot name="expanded-item" v-bind="props" />
            </td>
        </template>

        <!-- Add this block for each header with type 'date' -->
        <!-- TODO: Make a handler function for multiple types of fields not only date when needed. -->
        <template v-for="header in filteredHeaders" v-slot:[`item.${header.value}`]="{ item }">
            <template v-if="header?.type === 'date'">
                {{ item[header.value] ? toHrDate(item[header.value]) : "-"}}
            </template>
            <template v-else-if="header.type === 'cumulativeQuestions'">
                {{
                    item.disciplines.reduce((accumulator, currentDiscipline) => accumulator +
                        currentDiscipline.questions, 0)
                }}
            </template>
            <template v-else-if="header.type === 'cumulativeAllQuestions'">
                {{
                    item.sumativeDisciplines.reduce((accumulator, currentDiscipline) => accumulator +
                        currentDiscipline.questions, 0) + item.integrativeGroups.map(group =>
                            group.disciplines).flat().reduce((accumulator, currentDiscipline) => accumulator +
                                currentDiscipline.questions, 0)
                }}
            </template>
            <template v-else-if="header.type === 'cumulativeCredits'">
                {{
                    item.disciplines.reduce((accumulator, currentDiscipline) => accumulator +
                        currentDiscipline.credits, 0)
                }}
            </template>
            <template v-else>
                <slot :name="`item.${header.value}`" v-bind="{ item }">
                    {{ item[header.value] }}
                </slot>
            </template>
        </template>

        <template v-if="crud" #item.actions="{ item }">
            <div class="d-flex gap-1">
                <slot name="actions" :item="item"></slot>

                <slot name="add-btn" :item="item"></slot>
                <Btn icon="pencil" @click="edit(item)" />
                <Btn icon="delete" @click="remove(item)" />
            </div>
        </template>

        <template v-else #item.actions="{ item }">
            <slot name="actions" :item="item"></slot>
        </template>

    </v-data-table>
</template>

<script>
import utilsMixin from '@/mixins/utilsMixin.js'

export default {
    name: "DataTable",
    mixins: [utilsMixin],
    props: {
        headers: String,
        nested: Boolean,
        crud: Boolean,
        expandAll: Boolean,
        itemRowclass : {
            type : Function,
            require :false
        }
    },
    data() {
        return {
            expanded: [],
        }
    },
    computed: {
        filteredHeaders() {
            return this.$t(`tableHeaders.${this.headers}`).filter(header => header.text != 'field')
        },
    },
    methods: {
        edit(item) {
            this.$emit('edit', item);
        },
        remove(item) {
            console.log(item);
            if (window.confirm(this.$t("deleteConfirm"))) {
                this.$emit('delete', item);
            }
        },
        onPageUpdate(page) {
            this.$emit('update:page', page);
        },
        onUpdateItemsPerPage(itemsPerPage) {
            this.$emit('update:items-per-page', itemsPerPage);
        }
    },
    async mounted() {
        if (this.expandAll) {
            this.expanded = this.$attrs.items;
        }
    },
}
</script>
